<template>
  <b-collapse :id="`collapse-${id}`" class="mt-2">

    <ul class="text-right">

      <li class="dashboard-small" v-for="child in children">

        <div class="" v-if="child.children.length">
          <div class=""
               v-if="checkAccess(child)">

            <a href="javascript:;" @click="customAction" :style="`margin-right:${step + 15  }px`"
               v-b-toggle="`collapse-${child.id}`">
              {{ child.name }}
              <b-icon icon="arrow-down-circle" class="d-inline"></b-icon>
            </a>

            <sub-item :step="step+5" :id="child.id" :children="child.children"/>
          </div>
        </div>

        <div v-else>
          <router-link class="mr-3" v-if="checkAccess(child)" :to="child.route">
            {{ child.name }}
          </router-link>
        </div>


      </li>

    </ul>


  </b-collapse>
</template>

<script>
export default {
  name: "subItem",
  props: ['children', 'id', 'step', 'action'],
  methods: {
    customAction() {
      if (this.action !== undefined) {
        this.action()
      }
    },
    checkAccess(item) {
      let access = item.access
      let userProfile = this.$store.getters['User/getProfile'];
      if (access.length === 0) {
        return true
      }
      let userAccessNumber = `${userProfile.role}-${userProfile.type}`
      return access.indexOf(userAccessNumber) > -1
    }
  }
}
</script>

<style scoped>

ul li {
  list-style: none;
}




ul li a {
  color: #000;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 17px;
  outline: none;
}



@media only screen and (max-width: 991px) {
  ul li a {
    color: #fff;
  }
}


</style>